export default "__VITE_ASSET__B7OqNw4i__"